/**
 * 折价无忧
 */
import { DISCOUNTRECORD } from '../types';

export default {
    name: `${DISCOUNTRECORD}`,
    path: '/discountRecord',
    component: () => import(/* webpackChunkName: 'discountRecord' */ '@/views/discountRecord/'),
    redirect: { name: `${DISCOUNTRECORD}Index` },
    meta: {
        title: '折价无忧',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${DISCOUNTRECORD}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'discountRecord' */ '@/views/discountRecord/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${DISCOUNTRECORD}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'discountRecord' */ '@/views/discountRecord/detail/Detail.vue'),
        },
    ],
};
